/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Calendar from 'src/common/components/Calendar';
import { useHistory } from 'react-router-dom';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';
import { startLog } from 'src/api/modules/bitacora';
import interactionPlugin from '@fullcalendar/interaction';
import { useSelector } from 'react-redux';
import { organsAPI } from 'src/api/modules/organs';
import UtilInputs from 'src/common/components/UtilInputs';
import { Grid } from '@material-ui/core';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { getColorEvent } from 'src/utils/getColorsCalendar';
import { defaultOrganToCalendar, organToCalendar } from './utils/list_data';

const StartCalendar = () => {
	const history = useHistory();
	const [organs, setOrgans] = useState([]);
	const [session, setsessions] = useState([]);
	const [organID, setOrganID] = useState(defaultOrganToCalendar);
	const [dateCalendar, setDateCalendar] = useState();
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const reduxOrgan = useSelector((state) => state.organsByRol.organs);
	const showEverything = ['ADMINISTRADOR GENERAL', 'SISTEMA', 'RESPONSABLE DE NEGOCIO'];

	useEffect(() => {
		getOrgans();
		startLog('Ingreso a la vista Inicio del menu Seguimiento');
	}, []);

	useEffect(() => {
		if (organID.organoId !== '') {
			getSessionsByOrgan(organID.organoId);
		}
		if (
			showEverything.includes(systemLevelRole) === true &&
			dateCalendar !== undefined
		) {
			getDataFromApiSessions();
		}
	}, [dateCalendar]);

	const getDataFromApiSessions = () => {
		setsessions([]);
		sessionsAPI
			.getSesionsByDate(dateCalendar?.startDate, dateCalendar?.endDate) //aqui
			.then((response) => {
				if (response && response.length > 0) {
					let sessions = [];
					response.forEach((r) => {
						let formattedDate = r.fecha.split('-').reverse().join('-');
						let timeFormat = formattedDate + 'T' + r.hora;
						sessions.push({
							id: r.id,
							title: r.nombre_corto,
							start: timeFormat,
							eventColor: getColorEvent(timeFormat),
							borderColor: getColorEvent(timeFormat),
						});
					});
					setsessions([...(sessions || [])]);
					startLog('Consulto sesiones desde calendario de sesiones');
				}
			})
			.catch((e) => {
				notice('Ocurrio un error al cargar las sesiones');
			});
	};

	const getOrgans = () => {
		if (showEverything.includes(systemLevelRole) === true) {
			organsAPI
				.get('get')
				.then((response) => {
					if (response && response.length > 0) {
						setOrgans(getAllOrgans(response));
					}
				})
				.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
		} else {
			setOrgans(reduxOrgan);
		}
	};

	const getSessionsByOrgan = (organFromDropdown) => {
		setsessions([]);
		sessionsAPI
			.getByDate(organFromDropdown, dateCalendar?.startDate, dateCalendar?.endDate)
			.then((response) => {
				if (response && response.sesiones.length > 0) {
					let sessions = [];
					response.sesiones.forEach((r) => {
						let date = r.fecha;
						let formattedDate = date.split('-').reverse().join('-');
						let timeFormat = formattedDate + 'T' + r.hora;

						sessions.push({
							id: r.id,
							title: r.nombre_corto,
							start: timeFormat,
							eventColor: getColorEvent(timeFormat),
							borderColor: getColorEvent(timeFormat),
						});
					});
					setsessions([...(sessions || [])]);
				} else {
					notice(
						'No se encontraron sesiones para el organo seleccionado',
						'warning'
					);
				}
			})
			.catch((e) => notice('Error en la solicitud'));
	};

	const onResolutions = (data) => {
		const id = data.event.id;
		history.push(`/seguimiento/agregar-documentacion-resoluciones/${id}`);
	};
	const handleChange = (e) => {
		let { name, value } = e.target;
		setOrganID({ ...organID, [name]: value });
		getSessionsByOrgan(value);

		var organName = e.currentTarget.innerText.split('\n\n');
		startLog('Consulto sesiones del órgano colegiado: ' + organName[0]);
	};

	const getDates = (dates) => {
		let initialDates = {
			startDate: new Date(dates?.startStr).toLocaleDateString(),
			endDate: new Date(dates?.endStr).toLocaleDateString(),
		};
		setDateCalendar(initialDates);
	};

	return (
		<Grid style={{ background: 'white' }}>
			<UtilInputs
				onValuesChange={handleChange}
				formValues={organID}
				inputValues={organToCalendar(organs)}
			/>
			<Calendar
				data={session}
				eventClick={onResolutions}
				plugins={interactionPlugin}
				title="Calendario de Sesiones"
				datesSet={(dates) => getDates(dates)}
			/>
		</Grid>
	);
};

export default StartCalendar;
